@if (value() && value().length > 0) {
    <div
        #triggerOverlay="cdkOverlayOrigin"
        class="st-assignment-icon-list__value"
        cdkOverlayOrigin
        (mouseleave)="onMouseOut($event)"
        (mouseenter)="openOverlay()">
        <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="triggerOverlay"
            [cdkConnectedOverlayOpen]="isPanelOpen()"
            (attach)="panelAttached()">
            <st-assignments-overlay
                [data]="parentRecord()"
                [editable]="topicEditable()"
                [isPanelOpen]="isPanelOpen()"
                [onObjectOpen]="itemClicked" />
        </ng-template>
        <div class="st-assignment-icon-list__icons">
            @for (item of itemsToShow(); track item; let first = $first) {
                <st-icon
                    hasBorder
                    [attr.disabled]="cardDisabled()"
                    [type]="item?.PSTCoverageType"
                    [data]="item"
                    (click)="itemClicked.emit(item)" />
            }
        </div>
    </div>
    @if (shouldShowExtraAssignments()) {
        <div
            #triggerOverlay="cdkOverlayOrigin"
            class="st-assignment-icon-list__value__extra-items"
            cdkOverlayOrigin
            (mouseenter)="openOverlay()"
            (mouseleave)="onMouseOut($event)">
            +{{ extraAssignmentsCount() }}
        </div>
    }
}

@if (showAddButton()) {
    @if (hasButtonLabel()) {
        <button
            mat-button
            class="st-assignment-icon-list__add-assignment-button"
            [disabled]="cardDisabled()"
            [matMenuTriggerFor]="assignmentsMenu">
            <mat-icon> add_task </mat-icon>
            {{ addButtonLabel() }}
        </button>
    } @else {
        <button
            mat-icon-button
            class="st-assignment-icon-list__add-assignment-button"
            [disabled]="cardDisabled()"
            [matMenuTriggerFor]="assignmentsMenu">
            <mat-icon> add_task </mat-icon>
        </button>
    }
}

<mat-menu
    #assignmentsMenu="matMenu"
    class="st-assignment-icon-list__menu">
    <mat-selection-list
        hideSingleSelectionIndicator
        multiple="false">
        @for (item of assignmentTypes(); track item) {
            <mat-list-option
                class="st-assignment-icon-list__menu__option"
                [dir]="isRTL()"
                [value]="item.id"
                (click)="createAssignment(item.id)">
                <st-icon
                    matListItemIcon
                    [type]="item.id" />
                <div matListItemTitle>{{ item.title }}</div>
            </mat-list-option>
        }
    </mat-selection-list>
</mat-menu>
